import fr from "./fr.json";

export default {
	fr
};


export const DEFAULT_LANG = 'fr';